<template>
    <section class="app-ecommerce-details" v-if="loaded == true">
        <div class="card">
            <div class="card-body">
                <div class="row mx-auto ">
                    <div class="col-12 col-md-12 col-lg-12 mt-2"><h4 class="text-center">{{letter.letter_name}}</h4></div>
                    <letter-video :letter='letter'></letter-video>
                    <div class="col-12 col-md-6 col-lg-6 mt-2">
                        <strong>{{letter.short_description}}</strong><br>
                        <span class="card-text"><strong>Letter Type:</strong> <a class="company-name">{{ letter.letter_type }}</a></span>
                        <br> <br>
                        
                            <p class="card-text" v-if="letter.letter_round === 'Pre-Dispute'"><strong>Dispute Round:</strong> <span class="badge badge-secondary badge-glow company-name">{{ letter.letter_round }}</span></p>

                            <p class="card-text" v-else-if="letter.letter_round === 'Round 1'"><strong>Dispute Round:</strong> <span class="badge badge-info badge-glow company-name">{{ letter.letter_round }}</span></p>

                            <p class="card-text" v-else-if="letter.letter_round === 'Round 2'"><strong>Dispute Round:</strong> <span class="badge badge-success badge-glow company-name">{{ letter.letter_round }}</span></p>

                            <p class="card-text"  v-else-if="letter.letter_round === 'Round 3'"><strong>Dispute Round:</strong> <span class="badge badge-primary badge-glow company-name">{{ letter.letter_round }}</span></p>

                            <p class="card-text"  v-else-if="letter.letter_round === 'Round 4'"><strong>Dispute Round:</strong> <span class="badge badge-warning badge-glow company-name">{{ letter.letter_round }}</span></p>

                            <p class="card-text"  v-else-if="letter.letter_round === 'Response'"><strong>Dispute Round:</strong> <span class="badge badge-danger badge-glow company-name">{{ letter.letter_round }}</span></p>
                            <p class="card-text"  v-else-if="letter.letter_round === 'Complaint'"><strong>Dispute Round:</strong> <span class="badge badge-danger badge-glow company-name">{{ letter.letter_round }}</span></p>

                            <p class="card-text" v-else><strong>Dispute Round:</strong> <span class="badge badge-black badge-glow company-name">{{ letter.letter_round }}</span></p>

                        <div class="" v-html="letter.letter_description"/>
                        <hr />
                        <div class="d-flex flex-column flex-sm-row pt-1" v-if="userStore.user.isDIY == true">
                            <router-link
                                :to="{ name: 'dispute-report'}"
                                class="btn btn-outline-primary  mr-0 mr-sm-1 mb-1 mb-sm-0 right"
                                
                                >
                                    <i data-feather="arrow-left-circle" class="mr-50"></i>
                                    <span class="">Back</span>
                            </router-link>
                            <router-link
                                :to="{ name: 'dispute-letter', params: { letter: letter.slug } }"
                                class="btn btn-outline-primary  mr-0 mr-sm-1 mb-1 mb-sm-0 right"
                                
                                >
                                    <i data-feather="file-text"></i>
                                    <span>Create Dispute</span>
                            </router-link>
                        </div>
                        <div class="d-flex flex-column flex-sm-row pt-1"  v-else>
                            <a :href="$router.resolve({ name: 'dispute-report'}).href" class="btn btn-primary btn-cart mr-0 mr-sm-1 mb-1 mb-sm-0">
                                <i data-feather="arrow-left-circle" class="mr-50"></i>
                                <span class="">Back</span>
                            </a>
                            <a :href="createLetterClient" class="btn btn-outline-primary  mr-0 mr-sm-1 mb-1 mb-sm-0 right">
                                <span>Create Dispute</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <loading v-else />
</template>
<script>
import { ref } from 'vue'
import LetterVideo from './LetterVideo'
import {useLetterStore} from '../../../stores/LetterStore.js'
import {useUserStore} from '../../../stores/UserStore.js'
export default {
    components:{
        LetterVideo
    },
    props: {
        letter:{
            type: [Array, Object]
        }
    },
    setup(){
        const videoId=ref(),
        videoType=ref(),
        videoUrl=ref(),
        players=ref(),
        letter=ref(null),
        loaded=ref(false),
        createLetterClient = ref(null);
        return{
            videoId,
            videoType,
            videoUrl,
            players,
            letter,
            letterStore:useLetterStore(),
            userStore:useUserStore(),
            loaded,
            createLetterClient
        }
    },
    watch:{
        'letterStore.letter'(value) {
            console.log(value)
        },
        'letter'(value){
            if(value != null){
                const route = this.$router.resolve(
                    {
                        name: 'dispute-letter',
                        params: {
                            letter: value.slug,
                            client: this.$route.params.client,
                            team: this.$route.params.team,
                        }
                    }
                ); 
                this.createLetterClient = route.href
            }
            
        }
    },
    computed: {
    },
    mounted(){
        this.fetchLetter();
        
    },
    methods:{
        fetchLetter(){
            let params = { letter: this.$route.params.letter };
            const route = this.$router.resolve({
                name: 'disputes-letter-tutorial',
                params: params
            }),
            $this = this;
            axios.post(route.href)
            .then(function (response) {
                if(response.data.error != true) {
                    $this.loaded = true;
                    $this.letter = response.data.data
                    return;
                }
                toastr.error(response.data.message, 'Error!');
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }
}
</script>